<template>
    <span :class="badgeClasses">
        <slot />
    </span>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

export default defineComponent({
    name: 'Badge',
    setup() {
        const badgeClasses = computed(() => {
            // Exact React classes: inline-block px-4 py-2 bg-primary/10 text-primary rounded-full uppercase text-sm tracking-wider font-medium
            return 'inline-block px-4 py-2 bg-primary/10 text-primary rounded-full uppercase text-sm tracking-wider font-medium';
        });

        return {
            badgeClasses
        };
    }
});
</script>
